import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { promocodeCreate } from "../actions/promocodeActions";
import { useNavigate, Link } from "react-router-dom";
import { BDCPromocodes } from "../Data/data";
import axios from "axios";
import "../css/records.css";

const CreatePromocodeScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [code, setCode] = useState(null);
  const [codeType, setCodeType] = useState("price");
  const [codeValue, setCodeValue] = useState(null);
  const [category, setCategory] = useState("");
  const [product, setProduct] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);

  const adminInfo = useSelector((state) => state.adminInfo);

  const { adminData } = adminInfo;

  useEffect(() => {
    if (adminData) {
      if (adminData.accessLevel === "Viewer") {
        console.log("you're not allowed");
      }
    }
  }, []);

  const currencyFormat = (num) => {
    return "₹ " + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const submit = async (e) => {
    e.preventDefault();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const now = new Date();

    // Get the last day of the current month

    // Output
    let expirationDate;
    if (selectedKey > 6 && selectedKey <= 9) {
      expirationDate = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
    } else {
      expirationDate = new Date(now.getTime() + 24 * 60 * 60 * 1000); // +24 hours
    }

    try {
      const response = await axios.post(
        "https://d2c-storefront.emotorad.com/api/promocode/admin",
        {
          discountCode: code,
          discountType: "amount",
          discountValue: codeValue,
          category: category,
          expirationDate: expirationDate,
          usageLimit: 1,
          usageCount: 0,
          minOrderValue: 0,
          applicableProducts: product, //for all products
          status: "active",
          createdBy: adminData.name,
        },
        config,
      );

      if (response) {
        alert("Promocode Added Successfully");
        navigate("/promocode");
      }
    } catch (error) {
      console.error("Error submitting dealer lead:", error);
    }
  };

  useEffect(() => {
    const now = new Date();

    const istTime = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(now);

    const getPart = (type) =>
      istTime.find((part) => part.type === type)?.value || "";

    const milliseconds = now.getMilliseconds().toString().padStart(3, "0");

    const code = `EM${getPart("day")}${getPart("month")}${getPart(
      "year",
    )}-${getPart("hour")}${getPart("minute")}${milliseconds}`;
    setCode(code);
  }, []);

  return (
    <div className="container-fluid ps-0 ">
      <div className="row ">
        <div className="col-lg-2">
          <Sidebar active={4} />
        </div>
        <div
          className="col-lg-10 p-0"
          style={{
            overflowY: "scroll",
            height: "100vh",
          }}
        >
          <div className="records-page">
            <div className="records-header-row d-flex align-items-center">
              <Link
                to={"/promocode"}
                className="text-dark me-3"
                style={{ fontSize: "1.1em" }}
              >
                <i class="fa-solid fa-arrow-left"></i>
              </Link>
              <h4 className="records-heading">Create Promocode</h4>
            </div>
            <form onSubmit={submit}>
              <div className="row">
                <div className="col-lg-6 mb-3">
                  <div className="form-card">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        id="promo-code"
                        required
                        value={code}
                        readOnly
                        onChange={(e) =>
                          setCode(e.target.value.toLocaleUpperCase())
                        }
                        placeholder="Code"
                      />
                      <label for="promo-code">Code</label>
                    </div>

                    <div className="d-flex" style={{ gap: "0.75em" }}>
                      <div class="form-floating w-100 mb-3">
                        <select
                          onChange={(e) => setCodeType(e.target.value)}
                          class="form-select"
                          required
                          disabled
                          id="promo-code-type"
                          aria-label="Floating label select example"
                        >
                          <option selected value="price">
                            Price
                          </option>
                          <option value="percentage">Percentage</option>
                        </select>
                        <label for="promo-code-type">Code Type</label>
                      </div>

                      <div class="form-floating w-100 mb-3">
                        <input
                          type="number"
                          value={codeValue}
                          required
                          readOnly
                          onChange={(e) => setCodeValue(e.target.value)}
                          class="form-control"
                          id="promo-code-value"
                          placeholder="Value"
                        />
                        <label for="promo-code-value">Value</label>
                      </div>
                    </div>
                    <button className="btn btn-primary text-light w-100 records-action-btn justify-content-center">
                      <i class="fa-solid fa-check"></i> Create Promocode
                    </button>
                  </div>
                </div>
                <div className="col-lg-6 mb-3">
                  <div className="table-card">
                    <table className="records-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Discount Value</th>
                        </tr>
                      </thead>
                      <tbody style={{ cursor: "pointer" }}>
                        {BDCPromocodes?.map((item, i) => (
                          <tr key={item._id}>
                            <td>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="selectedProduct"
                                  onChange={(e) => {
                                    setProduct(item.productIds);
                                    setCodeValue(item.discount);
                                    setCategory(item.category);
                                    setSelectedKey(i);
                                  }}
                                  required
                                  id={"radio" + item._id}
                                  checked={item.key === selectedKey}
                                />
                              </div>
                            </td>
                            <td>
                              <label
                                className="w-100"
                                htmlFor={"radio" + item._id}
                              >
                                {item.productName}
                              </label>
                            </td>
                            <td>
                              <label
                                className="w-100"
                                htmlFor={"radio" + item._id}
                              >
                                {currencyFormat(item.discount)}
                              </label>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePromocodeScreen;
